import { AbpMultiTenancyService, PermissionCheckerService } from 'abp-ng2-module';
import { Injectable } from '@angular/core';
import { ApplicationInfoDto, GetCurrentLoginInformationsOutput, SessionServiceProxy, TenantLoginInfoDto, UserLoginInfoDto } from '@shared/service-proxies/service-proxies';
import { PermissionConsts } from '@shared/PermissionConsts';

@Injectable()
export class AppSessionService {
    private _user: UserLoginInfoDto;
    private _tenant: TenantLoginInfoDto;
    private _application: ApplicationInfoDto;
    private _serviceAsCoordinator: number[];

    constructor(
        private _sessionService: SessionServiceProxy,
        private permissionCheckerService: PermissionCheckerService,
        private _abpMultiTenancyService: AbpMultiTenancyService
    ) {}

    get application(): ApplicationInfoDto {
        return this._application;
    }

    get user(): UserLoginInfoDto {
        return this._user;
    }

    get userId(): number {
        return this.user ? this.user.id : null;
    }

    get tenant(): TenantLoginInfoDto {
        return this._tenant;
    }

    get tenantId(): number {
        return this.tenant ? this.tenant.id : null;
    }

    get servicesAsCoordinator(): number[] {
        return this._serviceAsCoordinator;
    }

    getShownLoginName(): string {
        const fullName = this.user.fullName;
        if (!this._abpMultiTenancyService.isEnabled) {
            return fullName;
        }

        return (this._tenant ? this._tenant.tenancyName : '.') + ' \\ ' + fullName;
    }

    isUserCoordinatorOfServiceOrCanEditAllServices(serviceId: number): boolean {
        return this.permissionCheckerService.isGranted(PermissionConsts.ServiceOperatorScheduled_Edit) || this._serviceAsCoordinator.includes(serviceId);
    }

    init(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this._sessionService
                .getCurrentLoginInformations()
                .toPromise()
                .then(
                    (result: GetCurrentLoginInformationsOutput) => {
                        this._application = result.application;
                        this._user = result.user;
                        this._tenant = result.tenant;
                        this._serviceAsCoordinator = result.servicesAsCoordinator;
                        resolve(true);
                    },
                    (err) => {
                        reject(err);
                    }
                );
        });
    }

    changeTenantIfNeeded(tenantId?: number): boolean {
        if (this.isCurrentTenant(tenantId)) {
            return false;
        }

        abp.multiTenancy.setTenantIdCookie(tenantId);
        location.reload();
        return true;
    }

    private isCurrentTenant(tenantId?: number) {
        if (!tenantId && this.tenant) {
            return false;
        } else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
            return false;
        }

        return true;
    }
}
